<pux-icon class="text-warning" v-if="isAlertIconVisible" :icon-tooltip="hinweisText" icon="warning"></pux-icon>